import Vue from 'vue'

/**权限指令**/
const has = Vue.directive('has', {
  inserted: function (el, binding, vnode) {
    // debugger
    let Actions = JSON.parse(sessionStorage.getItem('Actions'))
    let btnPermissionsStr = []
    if (Actions && Actions.length > 0) {
      Actions.forEach(it => {
        if (it.PermissionCode) {
         btnPermissionsStr.push(it.PermissionCode)
        }
      })
    }
    let arg = binding.arg
    if(!arg)
    {
        arg=binding.expression
    }
    if (btnPermissionsStr == undefined || btnPermissionsStr == null || btnPermissionsStr == []) {
      return false;
    }
    let flag = false
    if (btnPermissionsStr && btnPermissionsStr.length > 0) {
      btnPermissionsStr.forEach(it => {
        if (it === arg) {
          flag = true
        }
      })
    }
    if (!flag) {
      el.parentNode && el.parentNode.removeChild(el) || (el.style.display = 'none')
    }
  }
});
const nothas = Vue.directive('nothas', {
    inserted: function (el, binding, vnode) {
        // debugger
      let Actions = JSON.parse(sessionStorage.getItem('Actions'))
      let btnPermissionsStr = []
      if (Actions && Actions.length > 0) {
        Actions.forEach(it => {
          if (it.PermissionCode) {
           btnPermissionsStr.push(it.PermissionCode)
          }
        })
      }
      let arg = binding.arg
      if(!arg)
      {
          arg=binding.expression
      }
      if (btnPermissionsStr == undefined || btnPermissionsStr == null || btnPermissionsStr == []) {
        return false;
      }
      let flag = false
      if (btnPermissionsStr && btnPermissionsStr.length > 0) {
        btnPermissionsStr.forEach(it => {
          if (it === arg) {
            flag = true
          }
        })
      }
      if (flag) {
        el.parentNode && el.parentNode.removeChild(el) || (el.style.display = 'none')
      }
    }
  });
// // 权限检查方法
Vue.prototype.$_has = function (value) {
  let isExist = false;

  // 获取用户按钮权限
  let btnPermissionsStr = sessionStorage.getItem('Signs')

  if (btnPermissionsStr && btnPermissionsStr.includes(value)) {
    isExist = true;
  }
  return isExist;
};
export {
  has,
  nothas
}
//export default has


// WEBPACK FOOTER //
// ./src/utils/helper/btnPermissions.js